import store from './store';

export default {
  props: {
    operateId: {
      type: Number,
    },
  },
  data() {
    return {
      storeIndex: 0,
    };
  },
  created() {
    this.storeIndex = store.install(this.$store, this.$attrs);
  },
  mounted() {
    if (this.dashboardArea && !this.dashboardArea.length) {
      this.fetchDashboardAreaList({
        operateId: this.operateId ? this.operateId : null,
      });
    }
  },
  watch: {
    operateId(val) {
      this.fetchDashboardAreaList({
        operateId: val,
      });
    },
  },
  computed: {
    dashboardArea() {
      if (this.$store.state.base['dashboardArea' + this.storeIndex]) {
        return this.$store.getters[
          `dashboardArea${this.storeIndex}/dashboardArea`
        ];
      } else {
        return [];
      }
    },
    dashboardAreaFetching() {
      return this.$store.getters[
        `dashboardArea${this.storeIndex}/dashboardAreaFetching`
      ];
    },
  },
  methods: {
    fetchDashboardAreaList(entity) {
      return this.$store.dispatch(
        `dashboardArea${this.storeIndex}/fetchDashboardAreaList`,
        entity
      );
    },
    getAreaName(id) {
      let item = this.dashboardArea.find(area => area.id === id);
      if (item) {
        return item.areaName;
      } else {
        return '';
      }
    },
    getAreaOperatorInfo(id) {
      let item = this.dashboardArea.find(area => area.id === id);
      if (item) {
        return {
          rechargeOperateId: item.rechargeOperateId,
          rechargeOperateName: item.rechargeOperateName,
        };
      } else {
        return null;
      }
    },
  },
};
